var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0885d5;}.b{fill:#fff;font-size:16px;font-family:Lato-Black, Lato;font-weight:800;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-107 -381)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(107 381)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(117 397)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.528,
    y: 0
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkBlue);
export default __webpack_public_path__ + "static/media/question-mark-blue.276b598c01add675af2606131d60d3af.svg";
export { ForwardRef as ReactComponent };